import React from 'react';

export const component = props => (
  <svg
    style={{ width: '90%' }}
    aria-label={props.label}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 387.4 499.2"
  >
    <path
      fill={props.color}
      d="M188.2 396.6v-2.4-72a5.6 5.6 0 0 0-1.4-3.5Q100 229.9 13.4 141.4c-.7-.7-1.2-1.5-1.7-2.2l-.8.3V225c0 3.6-1.5 5.8-4.4 6.2a5.4 5.4 0 0 1-6.4-4.8 19.2 19.2 0 0 1 0-2.3v-97c0-5.5 1.7-7.3 7.2-7.3h97.3a21.7 21.7 0 0 1 2.3 0 5.4 5.4 0 0 1 .7 10.7 14.7 14.7 0 0 1-3.3.2H18.7L188 304V18.8l-1.9 1.8-58.8 58.8c-3.4 3.4-8.5 2.4-9.4-2-.3-1.4.4-3.2.9-4.7.2-.6.9-1 1.4-1.5L188.6 3c3.9-3.9 6.3-3.9 10.2 0l68.8 68.8c1.8 1.8 3.2 3.6 2.4 6.2a5.3 5.3 0 0 1-8.5 2.8 21 21 0 0 1-1.9-1.7l-58.3-58.3-2-1.9v284.7l169.5-173.3h-87.9a5.4 5.4 0 0 1-.5-10.8 14.7 14.7 0 0 1 2.5-.1h97.3c5.3 0 7.2 1.9 7.2 7v97.8c0 4.2-2 6.7-5.4 6.7a5.3 5.3 0 0 1-5.5-5v-87.7l-2 1.7-174 178.5a4.3 4.3 0 0 0-1.3 2.7v74.3l.1 1.2a51.1 51.1 0 0 1 37.8 23.6 48.8 48.8 0 0 1 7.5 35 51.3 51.3 0 0 1-102.2-5.4 51.5 51.5 0 0 1 45.8-53.1zm5.4 10.4a40.4 40.4 0 1 0 40.6 40.4 40.5 40.5 0 0 0-40.6-40.3z"
    />
  </svg>
);

export default component;



// WEBPACK FOOTER //
// ./src/components/UI/Img/ServiceSVG/automatedRoutingSVG.jsx